export default __webpack_public_path__ + "static/Zendesk-94f26bab9436cc3c6a2012de3b638d5c.png";